export const skillsData = [
 
  {
    title: "Adaptability & Resilience",
    description: "Gained through working diverse jobs such as waiter, barman, and gardener. Adapting to new roles, environments, and challenges has taught me resilience and how to thrive in dynamic, fast-paced settings."
  },
  {
    title: "Communication & Interpersonal Skills",
    description: "My time in customer-facing roles such as waiter, barman, and receptionist helped me develop excellent communication and interpersonal skills. I learned how to listen, respond, and empathize with a diverse range of people."
  },
  {
    title: "Multitasking & Time Management",
    description: "Juggling multiple responsibilities as a waiter and barman allowed me to sharpen my multitasking and time management skills. These experiences translate into my ability to handle multiple development tasks efficiently."
  },
  {
    title: "Problem-Solving & Creativity",
    description: "Whether troubleshooting issues at work or learning musical instruments on my own, I've developed creative problem-solving skills, which I now apply to my coding and project management work."
  },
  {
    title: "Leadership & Team Collaboration",
    description: "Through leading shifts as a first waiter and working in teams, I developed leadership and collaboration skills. These are crucial for coordinating development teams and delivering successful projects."
  },
  {
    title: "Attention to Detail",
    description: "Whether working as a barman or gardener, attention to detail was essential. This translates well into my web development work, where precision is critical for clean and functional code."
  },
  {
    title: "Self-Motivation & Continuous Learning",
    description: "From teaching myself web development to mastering new instruments, I am driven by a love for continuous learning and improvement. I stay up-to-date with the latest technologies and best practices."
  }
  ];
  
  export const technologiesData = [
    {
      title: "HTML & CSS",
      description: "Expertise in building responsive and modern web interfaces using HTML5 and CSS3, ensuring cross-browser compatibility and mobile responsiveness."
    },
    {
      title: "JavaScript & React",
      description: "Proficient in JavaScript, with experience building dynamic and interactive web applications using React.js, including state management and component-based architecture."
    },
    {
      title: "Ruby & Ruby on Rails",
      description: "Strong understanding of Ruby programming language and its framework, Ruby on Rails, to build robust backend applications with databases like PostgreSQL."
    },
    {
      title: "PostgreSQL",
      description: "Experience in using PostgreSQL as a database management system for full-stack web applications, handling data storage, and optimization."
    }
    // Add more technologies here
  ];